<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        {{ $t('Filters')}}
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col cols="12" md="12" class="mb-md-0 mb-2">
          <label>{{ $t('Owner') }}</label>
          <v-select multiple
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
            :value="ownersFilter"
            :options="ownersOptions"
            label="name"
            class="w-100"
            :clearable="true"
            :placeholder="$t('Filter BY Owner')"

            :reduce="val => val.id"
            @input="(val) => $emit('update:ownersFilter', val)"
          />
        </b-col>  

       


<!--        <b-col-->
<!--            cols="12"-->
<!--            md="6"-->
<!--            class="mb-md-0 mb-2"-->
<!--        >-->
<!--          <label>{{ $t('Devices') }}</label>-->
<!--          <v-select-->
<!--              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"-->
<!--              :value="deviceFilter"-->
<!--              :options="devicesOptions"-->
<!--              :placeholder="$t('Filter BY Device')"-->
<!--              :clearable="true"-->
<!--              :getOptionLabel="val => val.name"-->
<!--              class="w-100"-->
<!--              :reduce="val => val.id"-->
<!--              @input="(val) => $emit('update:deviceFilter', val)"-->
<!--          />-->
<!--        </b-col>-->


      </b-row>
      <b-row>
        <b-col cols="12" md="12" class="mb-md-0 mb-2">
          <label>{{ $t('Category') }}</label>

          <v-select multiple
              :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
              :value="categoriesFilter"
               label="name"
              :options="categoryOptions.map((i)=>({id:i,name:$t(i)}))"
              :placeholder="$t('Filter BY Category')"
              :clearable="true"
              class="w-100"
              :reduce="val => val.id"
              @input="(val) => $emit('update:categoriesFilter', val)"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="12" class="mb-md-0 mb-2">
          <label>{{ $t('Contract') }}</label>
          <v-select multiple
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
              :value="contractsFilter"
              :options="contractOptions"
              :placeholder="$t('Filter BY Contract')"
              :clearable="true"
              :getOptionLabel="val => val.name"
              class="w-100"
              :reduce="val => val.id"
              @input="(val) => $emit('update:contractsFilter', val)"
          />
        </b-col>

      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
  },
  props: {
    ownersFilter: {
      type: [Array],
      default: () => [],
    },

    groupFilter: {
      type: [Number, null],
      default: null,
    },

    typeFilter: {
      type: [Number, null],
      default: null,
    },

    contractsFilter: {
      type: [Array],
      default: () => [],
    },

    categoriesFilter: {
      type: [Array],
      default: () => [],
    },

    deviceFilter: {
      type: [Number, null],
      default: null,
    },

    ownersOptions: {
      type: Array,
      required: true,
    },

    groupOptions: {
      type: Array,
      required: true,
    },

    categoryOptions: {
      type: Array,
      required: true,
    },

    typeOptions: {
      type: Array,
      required: true,
    },

    contractOptions: {
      type: Array,
      required: true,
    },

    // devicesOptions: {
    //   type: Array,
    //   required: true,
    // },

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
